<template>
  <v-col
    style="flex: 0 0 310px"
  >
    <v-hover v-slot="{ hover }">
      <v-card
        color="grey lighten-4"
        rounded="lg"
        :elevation="hover ? 10 : 5"
        class="fill-height overflow-hidden"
        @click="$emit('click')"
      >
        <div class="d-flex flex-column fill-height">
          <div
            style="height: 160px; position: relative"
          >
            <img
              v-if="exercise.drill"
              :src="exercise.drill.preview"
              style="object-fit: cover; width: 100%; height: 100%"
              @click="mediaDialog = true"
              @click.prevent.stop
            >
            <img
              v-else-if="media && media.thumbnail_url"
              :src="media.thumbnail_url"
              style="object-fit: cover; width: 100%; height: 100%"
              @click="mediaDialog = true"
              @click.prevent.stop
            >
            <img
              v-else-if="media && media.mime_type.includes('image/')"
              :src="media.url"
              style="object-fit: cover; width: 100%; height: 100%"
              @click="mediaDialog = true"
              @click.prevent.stop
            >
            <video
              v-else-if="media && (media.mime_type.includes('video/') || ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv', 'flv', 'wmv'].indexOf(media.extension) > -1)"
              height="160px"
              :src="media.url"
              @click="mediaDialog = true"
              @click.prevent.stop
            />
            <v-img
              v-else
              height="160px"
            >
              <template v-slot:placeholder>
                <v-row
                  no-gutters
                  align="center"
                  justify="center"
                  class="fill-height"
                >
                  <v-col cols="auto">
                    <v-icon large>
                      fal fa-dumbbell
                    </v-icon>
                  </v-col>
                </v-row>
              </template>
            </v-img>
          </div>
          <v-divider />
          <div class="pa-4 grey--text text--darken-2 col">
            <div class="font-weight-medium mb-1">
              {{ exercise.name }}
            </div>
            <div
              class="caption mb-3"
              style="-webkit-line-clamp: 4; -webkit-box-orient: vertical; display: -webkit-box; overflow: hidden; width: 100%"
            >
              {{ exercise.description }}
            </div>
            <div>
              <v-tooltip
                v-for="tag in resolvedTags"
                :key="'tooltip' + tag.id"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    :key="'tag'+tag.id"
                    small
                    class="mr-1 mb-1 "
                    style="max-width: 250px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <strong class="mr-2">{{ tag.tag_label }}:</strong>
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ tag.value }}</span>
                  </v-chip>
                </template>
                <span>{{ tag.value }}</span>
              </v-tooltip>
            </div>
          </div>
          <v-divider v-if="allowAddToProtocol" />
          <div
            v-if="allowAddToProtocol"
            class="pa-3 col col-auto"
          >
            <v-menu
              offset-y
              open-on-hover
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  block
                  class="text-none"
                  v-on="showExerciseAddSelector ? on : undefined"
                  @click="!showExerciseAddSelector ? $emit('add') : undefined"
                >
                  <v-icon
                    small
                    left
                  >
                    far fa-plus
                  </v-icon>
                  {{ $t('training_builder.button.add_to_protocol') }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="$emit('add', true)">
                  <v-list-item-title>
                    {{ $t("training_builder.add_to_protocol.to_last", {lastItem: lastItemType === 'superset' ? 'superset' : 'section'}) }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('add')">
                  <v-list-item-title>
                    {{ $t("training_builder.add_to_protocol.after_last", {lastItem: lastItemType === 'superset' ? 'superset' : 'section'}) }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-card>
    </v-hover>

    <media-viewer-dialog
      v-if="exercise.drill"
      :visible.sync="mediaDialog"
      :media="[ exercise.drill.preview ]"
      view-only
    />

    <media-viewer-dialog
      v-else-if="media"
      :visible.sync="mediaDialog"
      :media="[ media ]"
      :view-media-id="media.id"
      view-only
      :can-download-video="false"
    />
  </v-col>
</template>
<script>
import { groupBy } from 'lodash'
import MediaViewerDialog from '@/components/dialogs/MediaViewerDialog.vue'

export default {
  name: 'ExerciseCard',
  components: { MediaViewerDialog },
  props: {
    exercise: {
      type: Object,
      required: true
    },
    lastItemType: {
      type: String,
      default: undefined
    },
    allowAddToProtocol: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mediaDialog: false
    }
  },
  computed: {
    resolvedTags() {
      return Object.values(groupBy(this.exercise.tags.filter(t => !t.is_hidden), 'tag_id')).map(tagGroup => {
        return {
          ...tagGroup[0],
          value: tagGroup.map(tg => tg.value).join(', ')
        }
      })
    },
    media() {
      if (!this.exercise.media || this.exercise.media.length === 0) return undefined

      return this.exercise.media[0]
    },
    showExerciseAddSelector() {
      return ['superset', 'group'].indexOf(this.lastItemType) !== -1
    }
  }
}
</script>
